export enum ContributionType {
	Clarification     = 1,
	Question          = 2,
	ProposalNote      = 3,
	RevisionNote      = 4,
	AmendmentFeedback = 5,
	Objection         = 6,
}

export enum ObjectionCategory {
	Cost                   = 1,
	Feasibility            = 2,
	Equity                 = 3,
	Risk                   = 4,
	UnintendedConsequences = 5,
	Legal                  = 6,
	Other                  = 7,
}

export enum ObjectionStatus {
	Open       = 1,
	Addressed  = 2,
	Deferred   = 3,
	OutOfScope = 4,
	Expired    = 5,
}

export enum VoteChoice {
	Support                 = 1,
	SupportWithReservations = 2,
	DoNotSupport            = 3,
}

export interface ContributionVersion {
	id: string;
	contributionId: string;
	versionNumber: number;
	body: string;
	createdAt: Date | null;
}

export interface Contribution {
	id: string;
	ideaId: string;
	contributionType: ContributionType;
	parentContributionId: string | null;
	currentVersionId: string | null;
	createdAt: Date | null;
}

export interface ContributionWithVersion {
	contribution: Contribution;
	version: ContributionVersion | null;
}

export interface ContributionThread {
	contribution: Contribution;
	version: ContributionVersion | null;
	replies: ContributionWithVersion[];
}

export interface Objection {
	id: string;
	ideaId: string;
	raisedByAccountId: string;
	category: ObjectionCategory;
	status: ObjectionStatus;
	body: string;
	resolvedAt: Date | null;
	createdAt: Date | null;
}

export interface ObjectionResponse {
	id: string;
	objectionId: string;
	body: string;
	createdAt: Date | null;
}

export interface ObjectionWithResponses extends Objection {
	responses: ObjectionResponse[];
}

export interface SimilarObjection {
	id:       string;
	body:     string;
	category: ObjectionCategory;
	status:   ObjectionStatus;
}

export interface Vote {
	id: string;
	ideaId: string;
	accountId: string;
	choice: VoteChoice;
	votedAt: Date | null;
	roundNumber: number;
}

export enum AmendmentPacketStatus {
	Open   = 1,
	Closed = 2,
}

export enum AmendmentItemStatus {
	Open   = 1,
	Passed = 2,
	Lapsed = 3,
}

export enum AmendmentVoteChoice {
	Approve = 1,
	Reject  = 2,
}

export interface AmendmentItem {
	itemId: string;
	sortOrder: number;
	contributionId: string | null;
	contributionType: ContributionType | null;
	body: string | null;
	contributedAt: Date | null;
	expiresAt: Date | null;
	status: AmendmentItemStatus;
	approved: boolean;
	approveCount: number;
	rejectCount: number;
}

export interface AmendmentPacket {
	id: string;
	ideaId: string;
	roundNumber: number;
	status: AmendmentPacketStatus;
	quorumPct: number;
	supermajorityPct: number;
	amendmentClosesAt: Date | null;
	openedAt: Date | null;
	closedAt: Date | null;
	items: AmendmentItem[];
}

export interface AmendmentVote {
	id: string;
	amendmentItemId: string;
	accountId: string;
	choice: AmendmentVoteChoice;
	isRatification: boolean;
	votedAt: Date | null;
}
